import React from 'react';
import { useSelector } from 'react-redux';
import { getFlightDetailsByAircraftId } from '../../../redux/selectors/flyingPage';
import { getEncodedIconUrl, getVehicleMarkerIcon } from '../../Flying/Map/utils/drawing/marker';

interface FlyingAircraftIconProps {
  aircraftId: string;
}
const HEIGHT = 26;
const WIDTH = 30;

export const FlyingAircraftIcon: React.FC<FlyingAircraftIconProps> = ({ aircraftId }) => {
  const flightDetails = useSelector(getFlightDetailsByAircraftId(aircraftId));

  if (!flightDetails) {
    <></>;
  }

  const lastPoint = flightDetails?.track.points[flightDetails.track.points.length - 1];
  const vehicleMarker = getVehicleMarkerIcon(
    flightDetails?.aircraft.aircraftIcon,
    flightDetails?.aircraft.aircraftIconColor,
    lastPoint
  );

  return <img src={getEncodedIconUrl(vehicleMarker)} width={WIDTH} height={HEIGHT} />;
};
